import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Page Components
import Home from './pages/Home';
import Services from './pages/Services';
import Nutrition from './pages/Nutrition';
import Oncology from './pages/Oncology';
import Cardiovascular from './pages/Cardiovascular';
import CareNavigators from './pages/CareNavigators';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/nutrition" element={<Nutrition />} />
          <Route path="/oncology" element={<Oncology />} />
          <Route path="/cardiovascular" element={<Cardiovascular />} />
          <Route path="/care-navigators" element={<CareNavigators />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;